var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMonthlyPaySeizureServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8087 57.2772L80.3001 30.4316L62.8516 51.1001V99.1562H93.8087V57.2772Z",
    fill: "#BFD9F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4473 56.2031H64.9148V99.156H17.4473V56.2031Z",
    fill: "#EAF5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.957,
    y: 69.0908,
    width: 12.3828,
    height: 12.8859,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75.2344,
    y: 73.3848,
    width: 10.319,
    height: 25.7717,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1027 30.4316H33.6236L17.4473 56.2033H64.9148L80.1027 30.4316Z",
    fill: "#BEBEBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.503 20.7061C46.8929 15.6563 50.8109 11.1562 55.8975 11.1562C60.9761 11.1562 64.8911 15.641 64.2862 20.6834C63.4265 27.8502 62.4278 37.3011 62.4278 42.5316C62.4278 51.7146 65.5063 60.1324 65.5063 60.1324L46.2656 60.1324C46.2656 60.1324 49.3441 52.0948 49.3441 42.5316C49.3441 37.1211 48.3587 27.7899 47.503 20.7061Z",
    fill: "#A26138"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6016 61.8829C34.6016 53.5107 41.3886 46.7236 49.7609 46.7236L62.0049 46.7236C70.3771 46.7236 77.1642 53.5107 77.1642 61.8829L34.6016 61.8829Z",
    fill: "#A26C4D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4355,
    y: 60.1299,
    width: 44.8948,
    height: 4.6644,
    rx: 2,
    fill: "#845430"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonthlyPaySeizureServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcMonthlyPaySeizureServiceMainMobile.6e11f3e4e41f4f2891a886363535849c.svg";
export { ForwardRef as ReactComponent };